    'use strict';

    import appConfigModule from '../appConfig/appConfig.module';
    var angular:angular.IAngularStatic =  require('angular');
    export default angular.module('nddUtils', [appConfigModule.name]);
    import './configurationUtil.service';
    import './jsonUtils.service';
    import './pnxUtil.service';
    import './templateUtil.service';
    import './dateUtils.service';





// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/nddUtils.module.ts